import React from 'react';
import Table from '@/common/components/Table';
import { DetailSection, DetailTitle } from '../../callAnalysis.styles';
import {
	formatAnalyzedAt,
	formatScore,
	getHistoryDetailsText,
	getHistoryTypeLabel,
} from '../../helpers/labels';

const HEADERS = ['Type', 'Date', 'Details'];

const HistorySection = ({ history }) => {
	if (!history?.length) {
		return null;
	}

	const raws = [...history].reverse().map((entry, index) => (
		<tr key={`${entry.type}-${entry.created_at}-${index}`}>
			<td>{getHistoryTypeLabel(entry.type)}</td>
			<td>{formatAnalyzedAt(entry.created_at)}</td>
			<td>
				{entry.data?.overall_score != null && (
					<span>
						Score: {formatScore(entry.data.overall_score)}
						{entry.data?.previous_score != null
							? ` (was: ${formatScore(entry.data.previous_score)})`
							: ''}
						{' · '}
					</span>
				)}
				{getHistoryDetailsText(entry)}
			</td>
		</tr>
	));

	return (
		<DetailSection>
			<DetailTitle>Change history</DetailTitle>
			<Table className='styled-table' headers={HEADERS} raws={raws} />
		</DetailSection>
	);
};

export default HistorySection;
